

















import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';

@Component
export default class EmptyStateCard extends Mixins(DeviceWidthCheckerMixin) { }
